module["exports"] = [
  "Nova",
  "Velha",
  "Grande",
  "Vila",
  "Município de"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pt_BR/address/city_prefix.js
// module id = 1620
// module chunks = 1